import * as React from 'react';
export const alipaySvg = React.forwardRef(function alipaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.537 11.983c1.121.496 0 3.306-1.184 2.726-1.34-.622-4.035-1.892-6.085-2.979-1.14 1.428-2.93 3.27-5.48 3.27C1.522 15 0 13.581 0 11.467c0-1.781 1.157-3.58 3.74-3.58 1.48 0 3 .446 4.818 1.12.336-.717.645-1.27.867-2.041l-6.57-.004V5.884l3.38.009-.058-1.832H2.061V2.999l4.116.003.028-1.351c0-.413.208-.651.571-.651H8.5l-.03 2.008 4.08.003v1.053H8.47l.058 1.84 3.338.008s-.442 2.081-1.39 3.827a75.035 75.035 0 0 0 6.06 2.244zM3.472 13.41c1.393 0 2.757-.887 4.062-2.638-1.744-.928-2.679-1.375-4.03-1.375-1.312 0-2.577.68-2.577 1.98 0 1.01.741 2.033 2.545 2.033z',
    }),
  );
});
alipaySvg.defaultProps = {
  height: '16',
  viewBox: '0 0 17 16',
  width: '17',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var alipay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'alipay',
  svg: alipaySvg,
};
